import { Modal, styled } from "@mui/material";

export const CoutryCodeSelectionDialog = styled(Modal)<any>`
  backdrop-filter: blur(5px);
  background: none;
  -webkit-backdrop-filter: blur(2px);
  .container {
    position: absolute;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 45rem;
    height: auto;
    min-height: 50rem;
    max-height: 50rem;
    background-color: var(--quaternary-theme-color);
    padding: 4rem 2rem;
    top: 50%;
    border-radius: 3rem;
  }

  .dialog-container {
    height: 100%;
    justify-content: space-between;
    row-gap: 2rem;
    flex-direction: column;
    position: relative;
    max-height: 100vh;
    display: flex;
    align-items: center;
  }

  .close-icon {
    cursor: pointer;
    position: absolute;
    top: -4%;
    right: -1%;
    fill: var(--nonary-lite-grey-color);
    width: 4rem;
    height: 1.4rem;
  }

  input {
    ::placeholder {
      text-overflow: "ellipsis !important";
      color: #2a2a2e;
      font-size: 1.9rem;
      font-weight: bold;
      font-family: "Comfortaa-Regular";
    }
  }

  .MuiInputAdornment-root img {
    width: 2.2rem;
    height: 2.2rem;
  }

  .error-message-container {
    margin-bottom: 10px !important;
  }

  .MuiOutlinedInput-root {
    align-items: center;
    text-align: center;
    border: none;
    color: white;
    font-size: 1.6rem;
  }
  :hover fieldset {
    border: none;
  }
  .Mui-focused fieldset {
    border: none;
  }
  .country-lists {
    flex-direction: column;
    row-gap: 2rem;
    height: calc(100% - 20rem);
    overflow-y: auto;
  }
  .country-code {
    column-gap: 1rem;
    align-items: center;
    cursor: pointer;
  }
  .line-break {
    width: 100%;
    min-height: 0.1rem;
    opacity: 0.5;
    background-color: var(--tertiary-lite-grey-color);
  }
  .country-code img {
    width: 3rem;
    height: 3rem;
  }
  .country-code p {
    font-family: "Comfortaa-Regular";
    font-size: 1.8rem;
    font-weight: bold;
    color: var(--octonary-grey-color);
  }
  .country-code span {
    font-family: "Comfortaa-Regular";
    font-size: 1.8rem;
    font-weight: bold;
    color: var(--quinary-grey-color);
  }

  @media screen and (max-width: 840px) {
    .container {
      bottom: 0%;
      top: auto;
      width: calc(100% - 20px);
      padding: 20px;
      border-top-left-radius: 4rem;
      border-top-right-radius: 4rem;
      transform: translate(-50%, 0%);
      max-height: 80%;
      min-height: 80%;
    }

    .close-icon {
      cursor: pointer !important;
      position: absolute;
      top: 0%;
      right: 0%;
      z-index: 1;
      fill: var(--nonary-lite-grey-color);
    }

    .country-code p {
      font-size: 1.4rem;
    }

    .country-code span {
      font-size: 1.4rem;
    }
  }
`;
